import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class FAQ {
    @observable id!: number;

    @observable slug!: string;
    @observable question!: string;
    @observable answer!: string;
    @observable category!: string;
    @observable language!: string;

    constructor(faq?: ModelProperties<FAQ>) {
        if (faq) {
            construct(this, faq);
        }
    }
}